module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-72x72-75e992fa2c7775823a25575fb7a4596c.png";